import React from 'react';
import Tippy from '../ReactTippy';

import FieldTreeResultService from '../../services/fieldTreeResult/FieldTreeResultService.js';

import Styles from '../../styles/componentStyle/fieldTreeResult/fieldTreeResult.scss';

/**
 * 入場人数との差異データテーブル
 * */
export const TableLayout = ({
  items,
  isOpenAllItems,
  toggleAllItems,
  toggleTableRow,
  displayIndividual,
  displayTotal,
}) => {
  return (
    <div className={`${Styles.table} master-slide-view__body`}>
      <table className='data-table'>
        <thead className='data-table__header'>
          <tr>
            <th className='data-table__head toggle_collapse'>
              開閉
              <button className='btn-icon--xs--dark' onClick={toggleAllItems}>
                <i
                  className={`i-warrow-${
                    isOpenAllItems ? 'top' : 'bottom'
                  } i-2x`}
                />
              </button>
            </th>
            {data.tableTitles.slice(1).map((title, index) => (
              <th className={`data-table__head ${title.name}`} key={index}>
                {title.label}
                {title.detail ? (
                  <React.Fragment>
                    <br /> {title.detail}
                  </React.Fragment>
                ) : (
                  ''
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='data-table__group show' style={{ overflow: scroll }}>
          {items.map((item, index) => {
            return (
              <TableRow
                fieldTreeResult={item}
                toggleTableRow={toggleTableRow}
                displayIndividual={displayIndividual}
                displayTotal={displayTotal}
                key={index}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const TableRow = ({
  fieldTreeResult,
  toggleTableRow,
  displayIndividual,
  displayTotal,
}) => {
  const tooltipStyle = {
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
    color: 'white',
    maxWidth: '400px',
    wordWrap: 'break-word',
  };
  const companyNameTooltip = (
    <React.Fragment>
      {fieldTreeResult.company_name}
      <br /> {fieldTreeResult.job_names}
    </React.Fragment>
  );

  if (!fieldTreeResult.isPrimeChild) {
    const isParent = !fieldTreeResult.isChild && !fieldTreeResult.isMyCompany;
    if (isParent) {
      displayIndividual = false;
    }
    if (!fieldTreeResult.isMyCompany) {
      displayTotal = false;
    }
  } else {
    if (fieldTreeResult.nest_no > 1) {
      displayTotal = false;
    }
  }

  return (
    <tr
      className={`data-table__item ${
        fieldTreeResult.isMyCompany ? 'my_company' : ''
      }`}
    >
      <td className='data-table__cell toggle_collapse'>
        {fieldTreeResult.canBeCollapsed && (
          <button
            className='btn-icon--sm'
            onClick={() => toggleTableRow(fieldTreeResult.id)}
          >
            <i
              className={
                fieldTreeResult.isOpened
                  ? 'i-warrow-top i-2x'
                  : 'i-warrow-bottom i-2x'
              }
            />
          </button>
        )}
      </td>
      <td className='data-table__cell data-table__cell--xl partner_company_name'>
        <div className='data-table__content flex-wrapper'>
          <p className={`nest-no nest-no-${fieldTreeResult.nest_no}`}>
            {fieldTreeResult.nest_no + data.nestNoSuffix}
          </p>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            html={<div style={tooltipStyle}>{companyNameTooltip}</div>}
          >
            <div className='partner-company-info sys-tooltip'>
              <p className='data-table__text-wrap'>
                {fieldTreeResult.company_name}
              </p>
              <p className='data-table__text-wrap occupation'>
                {fieldTreeResult.job_names}
              </p>
            </div>
          </Tippy>
        </div>
      </td>
      <td className='data-table__cell infoboxes'>
        <div className='data-table__content'>
          <div className='box-info-wrapper'>
            {displayIndividual && (
              <div className='box-info_noline'>
                {data.infoboxTitle.individual}
              </div>
            )}
          </div>
          <div className='box-info-wrapper'>
            {displayTotal && (
              <div className='box-info_noline'>{data.infoboxTitle.total}</div>
            )}
          </div>
        </div>
      </td>
      <td className='data-table__cell work_schedule'>
        <div className='data-table__content'>
          <p className='data-table__text-wrap'>
            {displayIndividual &&
              FieldTreeResultService.buildCellString(
                fieldTreeResult.work_schedule_daywork,
                fieldTreeResult.work_schedule
              )}
          </p>
          <p className='data-table__text-wrap'>
            {displayTotal &&
              FieldTreeResultService.buildCellString(
                fieldTreeResult.work_schedule_daywork_total,
                fieldTreeResult.work_schedule_total
              )}
          </p>
        </div>
      </td>
      <td className='data-table__cell work_result'>
        <div className='data-table__content'>
          <p className='data-table__text-wrap'>
            {displayIndividual &&
              FieldTreeResultService.buildCellString(
                fieldTreeResult.work_result_daywork,
                fieldTreeResult.work_result
              )}
          </p>
          <p className='data-table__text-wrap'>
            {displayTotal &&
              FieldTreeResultService.buildCellString(
                fieldTreeResult.work_result_daywork_total,
                fieldTreeResult.work_result_total
              )}
          </p>
        </div>
      </td>
      <td className='data-table__cell in_out_days'>
        <div className='data-table__content'>
          <p className='data-table__text-wrap'>
            {displayIndividual && fieldTreeResult.in_out_days}
          </p>
          <p className='data-table__text-wrap'>
            {displayTotal && fieldTreeResult.in_out_days_total}
          </p>
        </div>
      </td>
      <td className='data-table__cell result_difference'>
        <div className='data-table__content'>
          <p className='data-table__text-wrap'>
            {displayIndividual && fieldTreeResult.result_difference}
          </p>
          <p className='data-table__text-wrap'>
            {displayTotal && fieldTreeResult.result_difference_total}
          </p>
        </div>
      </td>
      <td className='data-table__cell fulfillment_rate'>
        <div className='data-table__content'>
          <p
            className={`data-table__text-wrap ${
              fieldTreeResult.fulfillmentRateComplete ? '' : 'red'
            }`}
          >
            {displayIndividual && fieldTreeResult.fulfillment_rate}
          </p>
          <p
            className={`data-table__text-wrap ${
              fieldTreeResult.fulfillmentRateTotalComplete ? '' : 'red'
            }`}
          >
            {displayTotal && fieldTreeResult.fulfillment_rate_total}
          </p>
        </div>
      </td>
    </tr>
  );
};

// 定数
const data = {
  tableTitles: [
    { name: 'toggle_collapse', label: '' },
    { name: 'partner_company_name', label: '協力会社名' },
    { name: 'infoboxes', label: '' },
    {
      name: 'work_schedule',
      label: '作業予定 (常傭 / 請負)',
      detail: '(人工)',
    },
    { name: 'work_result', label: '作業実績 (常傭 / 請負)', detail: '(人工)' },
    { name: 'in_out_days', label: '入退場実績', detail: '(人数)' },
    { name: 'result_difference', label: '実績差異' },
    { name: 'fulfillment_rate', label: '充足率' },
  ],
  infoboxTitle: {
    individual: '個社',
    total: '合計',
  },
  nestNoSuffix: '次',
};



// WEBPACK FOOTER //
// ./src/components/tables/FieldTreeResultTable.jsx